import React, {useState} from 'react'
import {Modal} from '@thryvlabs/maverick'
import {
  KP11ManageIncentiveModalWrapStyle,
  KP11ManagePlanIncentiveModalBodyStyle,
  KP11ManagePlanIncentiveModalFooterStyle,
  KP11ManagePlanIncentiveModalHeaderStyle,
} from './kp-11Link-order-summary-styles'

const KP11LinkManagePlanIncentive = ({
  setIsModalOpen,
  plansIncentiveGroups,
  togglePlanIncentive,
}) => {
  return (
    <KP11ManageIncentiveModalWrapStyle>
      <KP11ManagePlanIncentiveModalHeaderStyle>
        Eligible Incentives for Selected Plans
      </KP11ManagePlanIncentiveModalHeaderStyle>

      <KP11ManagePlanIncentiveModalBodyStyle>
        {plansIncentiveGroups &&
        Object.keys(plansIncentiveGroups).length > 0 ? (
          Object.keys(plansIncentiveGroups).map(planDesc => (
            <div key={planDesc} className="pi-wrap">
              <div className="pi-title">{planDesc}</div>
              {(plansIncentiveGroups[planDesc] || []).map(c => (
                <label key={c.coupon_code} className="pi-checkbox">
                  <input
                    type="checkbox"
                    checked={c.isChecked}
                    disabled={c.isDisabled}
                    onChange={e =>
                      togglePlanIncentive(
                        planDesc,
                        c.coupon_code,
                        e.target.checked,
                      )
                    }
                  />
                  {c.coupon_desc || c.coupon_code}
                </label>
              ))}
            </div>
          ))
        ) : (
          <div className="pi-empty">No plan incentives available</div>
        )}
      </KP11ManagePlanIncentiveModalBodyStyle>

      <KP11ManagePlanIncentiveModalFooterStyle>
        <button className="pi-close-btn" onClick={() => setIsModalOpen(false)}>
          Close
        </button>
      </KP11ManagePlanIncentiveModalFooterStyle>
    </KP11ManageIncentiveModalWrapStyle>
  )
}

export default function KP11LinkManagePlanIncentiveButtonWithModal({
  plansIncentiveGroups,
  togglePlanIncentive,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = async () => {
    setIsModalOpen(true)
  }

  return (
    <>
      <button onClick={handleClick} className="incentive-btn">
        Manage Incentives
      </button>
      {isModalOpen && (
        <Modal
          variant="lg"
          btnType="text"
          hideX={true}
          disableBackdropClick={true}
          openOnLoad
          onClose={() => {
            setIsModalOpen(false)
          }}
          width="auto"
        >
          <KP11LinkManagePlanIncentive
            setIsModalOpen={setIsModalOpen}
            plansIncentiveGroups={plansIncentiveGroups}
            togglePlanIncentive={togglePlanIncentive}
          ></KP11LinkManagePlanIncentive>
        </Modal>
      )}
    </>
  )
}
